import type { PaletteMode, ThemeOptions } from '@mui/material'
import { TRIPLET_CLARO } from './palette'

/**
 * Sombras do arsal-drive. O detalhe que define o "look" da casa e que no modo
 * claro elas NAO sao pretas: sao coloridas no mesmo rgb do texto (50, 71, 92).
 * Trocar por preto deixa a interface suja e pesada.
 *
 * As 25 entradas sao geradas a partir do triplet para nao repetir a cor 70 vezes.
 */
const Shadows = (mode: PaletteMode): ThemeOptions['shadows'] => {
  const rgb = mode === 'light' ? TRIPLET_CLARO : '0, 0, 0'
  const c = (alpha: number) => `rgba(${rgb}, ${alpha})`

  return [
    'none',
    `0px 2px 1px -1px ${c(0.2)}, 0px 1px 1px 0px ${c(0.14)}, 0px 1px 3px 0px ${c(0.12)}`,
    `0px 3px 1px -2px ${c(0.2)}, 0px 2px 2px 0px ${c(0.14)}, 0px 1px 5px 0px ${c(0.12)}`,
    `0px 4px 8px -4px ${c(0.42)}`,
    `0px 6px 18px -8px ${c(0.56)}`,
    `0px 3px 5px -1px ${c(0.2)}, 0px 5px 8px 0px ${c(0.14)}, 0px 1px 14px 0px ${c(0.12)}`,
    `0px 2px 10px 0px ${c(mode === 'light' ? 0.1 : 0.2)}`,
    `0px 4px 5px -2px ${c(0.2)}, 0px 7px 10px 1px ${c(0.14)}, 0px 2px 16px 1px ${c(0.12)}`,
    `0px 5px 5px -3px ${c(0.2)}, 0px 8px 10px 1px ${c(0.14)}, 0px 3px 14px 2px ${c(0.12)}`,
    `0px 5px 6px -3px ${c(0.2)}, 0px 9px 12px 1px ${c(0.14)}, 0px 3px 16px 2px ${c(0.12)}`,
    `0px 6px 6px -3px ${c(0.2)}, 0px 10px 14px 1px ${c(0.14)}, 0px 4px 18px 3px ${c(0.12)}`,
    `0px 6px 7px -4px ${c(0.2)}, 0px 11px 15px 1px ${c(0.14)}, 0px 4px 20px 3px ${c(0.12)}`,
    `0px 7px 8px -4px ${c(0.2)}, 0px 12px 17px 2px ${c(0.14)}, 0px 5px 22px 4px ${c(0.12)}`,
    `0px 7px 8px -4px ${c(0.2)}, 0px 13px 19px 2px ${c(0.14)}, 0px 5px 24px 4px ${c(0.12)}`,
    `0px 7px 9px -4px ${c(0.2)}, 0px 14px 21px 2px ${c(0.14)}, 0px 5px 26px 4px ${c(0.12)}`,
    `0px 8px 9px -5px ${c(0.2)}, 0px 15px 22px 2px ${c(0.14)}, 0px 6px 28px 5px ${c(0.12)}`,
    `0px 8px 10px -5px ${c(0.2)}, 0px 16px 24px 2px ${c(0.14)}, 0px 6px 30px 5px ${c(0.12)}`,
    `0px 8px 11px -5px ${c(0.2)}, 0px 17px 26px 2px ${c(0.14)}, 0px 6px 32px 5px ${c(0.12)}`,
    `0px 9px 11px -5px ${c(0.2)}, 0px 18px 28px 2px ${c(0.14)}, 0px 7px 34px 6px ${c(0.12)}`,
    `0px 9px 12px -6px ${c(0.2)}, 0px 19px 29px 2px ${c(0.14)}, 0px 7px 36px 6px ${c(0.12)}`,
    `0px 10px 13px -6px ${c(0.2)}, 0px 20px 31px 3px ${c(0.14)}, 0px 8px 38px 7px ${c(0.12)}`,
    `0px 10px 13px -6px ${c(0.2)}, 0px 21px 33px 3px ${c(0.14)}, 0px 8px 40px 7px ${c(0.12)}`,
    `0px 10px 14px -6px ${c(0.2)}, 0px 22px 35px 3px ${c(0.14)}, 0px 8px 42px 7px ${c(0.12)}`,
    `0px 11px 14px -7px ${c(0.2)}, 0px 23px 36px 3px ${c(0.14)}, 0px 9px 44px 8px ${c(0.12)}`,
    `0px 11px 15px -7px ${c(0.2)}, 0px 24px 38px 3px ${c(0.14)}, 0px 9px 46px 8px ${c(0.12)}`,
  ]
}

export default Shadows
